import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Search,
    Funnel,
    Edit2,
    Plus,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    CircleCheck
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import { Info } from 'lucide-react';
import Tooltip from '../addentities/Tooltip';
import apiHelper from '../../apiHelper';
import { copyToClipboard } from '../../utils/helper';

// Dummy data (10 rows) matching the screenshot exactly
const dummyDataOffboarded = [

];

const PAGE_SIZE = 10; // Display all 10 rows on one page

export default function Employee() {
    const [activeTab, setActiveTab] = useState('current-employees');
    const [employeeData, setEmployeeData] = useState([]);
    const history = useHistory();
    const location = useLocation();
    const [successMessage, setSuccessMessage] = useState('');
    

    // Breadcrumbs (you can adjust these if needed)
    const breadcrumbs = ["Organisations", "Employees"];

    // Search, pagination, and multi‐selection state
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState([]);
    const [filterDepartments, setFilterDepartments] = useState([]);
    const [filterEntities, setFilterEntities] = useState([]);
    const [filterManagers, setFilterManagers] = useState([]);
    const [filterWorkplaces, setFilterWorkplaces] = useState([]);
    const [filterOnboardDate, setFilterOnboardDate] = useState([]);
    const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');
    const [entitySearchTerm, setEntitySearchTerm] = useState('');
    const [managerSearchTerm, setManagerSearchTerm] = useState('');
    const [workplaceSearchTerm, setWorkplaceSearchTerm] = useState('');
    const [onboardDateSearchTerm, setOnboardDateSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedIds, setSelectedIds] = useState([]);
    // Offboarded Employees Tab
    const [offboardedSearchTerm, setOffboardedSearchTerm] = useState('');
    const [offboardedCurrentPage, setOffboardedCurrentPage] = useState(1);
    const [offboardedSelectedIds, setOffboardedSelectedIds] = useState([]);
    const [offboardedFilterWorkplaces, setOffboardedFilterWorkplaces] = useState([]);
    const [offboardedWorkplaceSearchTerm, setOffboardedWorkplaceSearchTerm] = useState('');

    // Bulk Edit Drawer (right‐side) state
    const [bulkEditOpen, setBulkEditOpen] = useState(false);
    const bulkDrawerRef = useRef(null);

    // “Suppress highlight” flag: if true, even checked rows will not be highlighted
    const [suppressHighlight, setSuppressHighlight] = useState(false);

    // Single‐row Drawer state (unchanged)
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerTab, setDrawerTab] = useState('entity-info');
    const [selectedRow, setSelectedRow] = useState(null);

    // Filtered list of rows, based on searchTerm
    const filtered = useMemo(() => {
        const term = searchTerm.toLowerCase();
        return employeeData.filter(d => {
            const matchesSearch =
                !searchTerm ||
                (d.uuid ? d.uuid.toLowerCase().includes(term) : false) ||
                (d.employee_first_name ? d.employee_first_name.toLowerCase().includes(term) : false) ||
                (d.employee_last_name ? d.employee_last_name.toLowerCase().includes(term) : false) ||
                (d.display_name ? d.display_name.toLowerCase().includes(term) : false) ||
                (d.company_email ? d.company_email.toLowerCase().includes(term) : false) ||
                (d.personal_email ? d.personal_email.toLowerCase().includes(term) : false) ||
                (d.job_title_data?.job_title_name ? d.job_title_data.job_title_name.toLowerCase().includes(term) : false) ||
                (d.notes ? d.notes.toLowerCase().includes(term) : false);
            const matchesStatus = filterStatus.length === 0 || filterStatus.includes(d.status_name);
            const matchesDepartments = filterDepartments.length === 0 || filterDepartments.some(dept => d.departments_names?.toLowerCase().includes(dept.toLowerCase()));
            const matchesEntities = filterEntities.length === 0 || filterEntities.some(entity => d.entities_names?.toLowerCase().includes(entity.toLowerCase()));
            const matchesManagers = filterManagers.length === 0 || filterManagers.some(manager => d.manager?.toLowerCase().includes(manager.toLowerCase()));
            const matchesWorkplaces = filterWorkplaces.length === 0 || filterWorkplaces.some(workplace => d.workplaces_names?.toLowerCase().includes(workplace.toLowerCase()));
            const matchesOnboardDate = filterOnboardDate.length === 0 || filterOnboardDate.includes(d.onboard_date);
            return matchesSearch && matchesStatus && matchesDepartments && matchesEntities && matchesManagers && matchesWorkplaces && matchesOnboardDate;
        });
    }, [searchTerm, employeeData, filterStatus, filterDepartments, filterEntities, filterManagers, filterWorkplaces, filterOnboardDate]);

    const offboardedFiltered = useMemo(() => {
        const term = offboardedSearchTerm.toLowerCase();
        return dummyDataOffboarded.filter(d =>
            d.name.toLowerCase().includes(term) ||
            d.email.toLowerCase().includes(term) ||
            d.department.toLowerCase().includes(term) ||
            d.manager.toLowerCase().includes(term) ||
            d.jobTitle.toLowerCase().includes(term) ||
            d.entity.toLowerCase().includes(term) ||
            d.workplace.toLowerCase().includes(term)
        ).filter(d =>
            offboardedFilterWorkplaces.length === 0 || offboardedFilterWorkplaces.some(w => d.workplace.toLowerCase().includes(w.toLowerCase()))
        );
    }, [offboardedSearchTerm, offboardedFilterWorkplaces]);

    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const pageData = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);
    const offboardedTotalPages = Math.ceil(offboardedFiltered.length / PAGE_SIZE);
    const offboardedPageData = offboardedFiltered.slice((offboardedCurrentPage - 1) * PAGE_SIZE, offboardedCurrentPage * PAGE_SIZE);

    const [allPermissionGroups, setAllPermissionGroups] = useState([
        { role_name: 'Admin', id: '1' },
        { role_name: 'Editor', id: '2' },
        { role_name: 'Viewer', id: '3' },
        { role_name: 'IT', id: '4' },
    ]);
    const [allDepartments, setAllDepartments] = useState([
        { short_name: 'HQ', department_id: '1' },
        { short_name: 'Mister Mobile HQ', department_id: '2' },
        { short_name: 'Mister Mobile HQ 2', department_id: '3' },
    ]);
    const [allEntities, setAllEntities] = useState([
        { entity_short_name: 'HQ', entity_id: '1' },
        { entity_short_name: 'Mister Mobile HQ', entity_id: '2' },
        { entity_short_name: 'Mister Mobile HQ 2', entity_id: '3' },
    ]);
    const [allWorkplaces, setAllWorkplaces] = useState([
        { short_name: 'HQ', workplace_id: '1' },
        { short_name: 'Mister Mobile HQ', workplace_id: '2' },
        { short_name: 'Mister Mobile HQ 2', workplace_id: '3' },
    ]);
    const [allManagers, setAllManagers] = useState([
        { name: 'Abc', id: '1' },
        { name: 'Def', id: '2' },
        { name: 'Ghi', id: '3' },
    ]);

    // Toggle selecting a single row (checkbox)
    const toggleSelect = id => {
        setSelectedIds(ids => {
            const newIds = ids.includes(id)
                ? ids.filter(x => x !== id)
                : [...ids, id];

            // As soon as user toggles a checkbox, we should no longer suppress highlight
            setSuppressHighlight(false);
            return newIds;
        });
    };

    const toggleOffboardedSelect = id => {
        setOffboardedSelectedIds(ids => {
            const newIds = ids.includes(id)
                ? ids.filter(x => x !== id)
                : [...ids, id];

            setSuppressHighlight(false);
            return newIds;
        });
    };

    // Toggle “select all” on the current page
    const toggleAll = () => {
        setSelectedIds(prev => {
            const next =
                prev.length === pageData.length
                    ? []
                    : pageData.map(d => d.id);

            // As soon as user toggles “select all,” remove the suppression
            setSuppressHighlight(false);
            return next;
        });
    };

    const toggleOffboardedAll = () => {
        setOffboardedSelectedIds(prev => {
            const next =
                prev.length === offboardedPageData.length
                    ? []
                    : offboardedPageData.map(d => d.id);

            setSuppressHighlight(false);
            return next;
        });
    };

    // Whenever selectedIds changes, open or close the Bulk Edit drawer
    useEffect(() => {
        if (selectedIds.length > 0) {
            // setBulkEditOpen(true);
        } else {
            setBulkEditOpen(false);
        }
    }, [selectedIds]);

    // Close Bulk Edit drawer (HIDE it) when clicking outside
    // IMPORTANT: We do NOT clear selectedIds here! We only want to hide it,
    // and suppress row highlighting, until next user checkbox interaction.
    useEffect(() => {
        function handleClickOutsideBulk(event) {
            if (
                bulkEditOpen &&
                bulkDrawerRef.current &&
                !bulkDrawerRef.current.contains(event.target)
            ) {
                setBulkEditOpen(false);
                // **Do not clear `selectedIds` here.** Just suppress highlight until next toggle.
                setSuppressHighlight(true);
            }
        }
        document.addEventListener('mousedown', handleClickOutsideBulk);
        return () => document.removeEventListener('mousedown', handleClickOutsideBulk);
    }, [bulkEditOpen]);

    // When a row (except its checkbox) is clicked, open the single‐row drawer
    const onRowClick = (row) => {
        setSelectedRow(row);
        setDrawerTab('entity-info');
        setDrawerOpen(true);
    };

    // Remove one selected ID (removes its tag and unchecks the row)
    const removeSelectedId = (id) => {
        setSelectedIds(ids => {
            const next = ids.filter(x => x !== id);
            // Removing a tag is basically the same as unchecking a box: we can resume highlighting
            setSuppressHighlight(false);
            return next;
        });
    };

    const removeOffboardedSelectedId = (id) => {
        setOffboardedSelectedIds(ids => {
            const next = ids.filter(x => x !== id);
            setSuppressHighlight(false);
            return next;
        });
    };

    // Bulk Edit “Cancel”: close drawer & uncheck all
    const handleBulkCancel = () => {
        setBulkEditOpen(false);
        setSelectedIds([]);
        setSuppressHighlight(false);
    };

    // Bulk Edit “Save”: stubbed—logs to console and closes
    const handleBulkSave = () => {
        console.log("Bulk saved for IDs:", selectedIds);
        setBulkEditOpen(false);
        setSelectedIds([]);
        setSuppressHighlight(false);
    };

    // Dropdown (ellipsis) state & refs (unchanged)
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const dropdownRef = useRef(null);
    const buttonRefs = useRef({});
    const drawerRef = useRef(null);

    // Close single‐row Drawer when clicking outside
    useEffect(() => {
        function handleClickOutsideDrawer(event) {
            if (
                drawerOpen &&
                drawerRef.current &&
                !drawerRef.current.contains(event.target)
            ) {
                setDrawerOpen(false);
                setSelectedRow(null);
                // If we click outside the single‐row drawer, we unselect that row but leave bulk selections alone
                setSelectedIds(ids =>
                    selectedRow ? ids.filter(id => id !== selectedRow.id) : ids
                );
            }
        }
        document.addEventListener('mousedown', handleClickOutsideDrawer);
        return () =>
            document.removeEventListener('mousedown', handleClickOutsideDrawer);
    }, [drawerOpen, selectedRow]);

    // Dropdown positioning state
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    // Toggle the per‐row dropdown menu
    const toggleDropdown = (id) => {
        if (dropdownOpenId === id) {
            setDropdownOpenId(null);
        } else {
            const btn = buttonRefs.current[id];
            if (btn) {
                const rect = btn.getBoundingClientRect();
                const dropdownWidth = 150;
                const dropdownHeight = 100;

                let left = rect.left + window.scrollX - dropdownWidth + rect.width;
                if (left < window.scrollX + 8) {
                    left = window.scrollX + 8;
                }

                let top = rect.bottom + window.scrollY;
                if (top + dropdownHeight > window.scrollY + window.innerHeight) {
                    top = rect.top + window.scrollY - dropdownHeight;
                }

                setDropdownPosition({ top, left });
            }
            setDropdownOpenId(id);
        }
    };
    const offboardRef = useRef(null);
    const [offboardModalOpen, setOffboardModalOpen] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); // optional
    const handleOffboardConfirm = () => {
        // Your logic here (e.g., API call, toast, state update)
        console.log("Offboarding employee:", selectedEmployeeId);
        setOffboardModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (offboardRef.current && !offboardRef.current.contains(event.target)) {
                setOffboardModalOpen(false);
        }
        }

        if (offboardModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [offboardModalOpen]);

    useEffect(() => {
        async function fetchInitialData() {
            try {
                // Parallel calls for dependencies
                const [
                    departmentsRes,
                    entitiesRes,
                    workplacesRes,
                    permissionGroupsRes
                ] = await Promise.all([
                    apiHelper('departments/list/'),
                    apiHelper('entities/list/'),
                    apiHelper('entities/workplaces/'),
                    apiHelper('roles/list/'),
                ]);

                // Wait for all JSON conversions
                const [
                    departmentsSet,
                    entitiesSet,
                    workplacesSet,
                    permissionGroupsSet
                ] = await Promise.all([
                    departmentsRes.ok ? departmentsRes.json() : [],
                    entitiesRes.ok ? entitiesRes.json() : [],
                    workplacesRes.ok ? workplacesRes.json() : [],
                    permissionGroupsRes.ok ? permissionGroupsRes.json() : [],
                ]);

                // Set state for all
                setAllDepartments(departmentsSet);
                setAllEntities(entitiesSet);
                setAllWorkplaces(workplacesSet);
                setAllPermissionGroups(permissionGroupsSet);
                console.log("workplaces",workplacesSet)
                // Now fetch employees
                const employeesRes = await apiHelper('users/list/');
                if (employeesRes.ok) {
                    const result = await employeesRes.json();
                    // if (response && response.ok) {
                    //     const result = await response.json();
                    setAllManagers(result)
                    // console.log(result);
                    let sampleData = result;

                    sampleData = sampleData.map(item => {
                        const manager = allManagers.find(m => m.display_name === item.manager?.toString());
                        const departmentNames = item.departments?.map(id => {
                            const departments = departmentsSet.find(m => m.department_id == id.toString());
                            return departments ? departments.short_name : '';
                        });
                        const workplacesNames = item.workplaces?.map(id => {
                            const workplaces = workplacesSet.find(m => m.workplace_id == id.toString());
                            console.log(workplaces);
                            return workplaces ? workplaces.workplace_short_name : '-';
                        });
                        const entitiesNames = item.entities?.map(id => {
                            const entities = entitiesSet.find(m => m.entity_id == id.toString());
                            return entities ? entities.entity_short_name : '';
                        });

                        return {
                            ...item,
                            status_name: item.status == 1 ? 'Active' : 'Inactive',
                            manager_name: manager ? manager.display_name : '',
                            departments_names: departmentNames ? departmentNames.join(', ') : '-',
                            workplaces_names: workplacesNames ? workplacesNames.join(', ') : '-',
                            entities_names: entitiesNames ? entitiesNames.join(', ') : '-',
                        };
                    });
                    setEmployeeData(sampleData);
                    // }
                    // setEmployeeData(employees);
                }

            } catch (error) {
                console.error('Failed to fetch initial data:', error);
            }
        }

        fetchInitialData();
    }, []);

    const editEmployee = () => {

        if (selectedIds.length == 1) {
            history.push(`/employee/edit-employee/${selectedIds[0]}`)
        }
        else if (dropdownOpenId) {
            history.push(`/employee/edit-employee/${dropdownOpenId}`)
        }

    }

   
    const openIdRef = useRef(null);
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (openIdRef.current) {
        navigator.clipboard.writeText(openIdRef.current.innerText);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000); // reset after 1 sec
        }
    };
    const filterButtonRef = useRef(null);
    const filterPopupRef = useRef(null);
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
    const formattedDate = new Date(selectedRow?.onboard_date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
    });
    const handleCheckboxChange = (setter, value) => (e) => {
        const isChecked = e.target.checked;
        setter((prev) => (isChecked ? [...prev, value] : prev.filter((v) => v !== value)));
        setCurrentPage(1);
    };
    useEffect(() => {
    function handleClickOutsideDropdown(event) {
        if (
            dropdownOpenId !== null &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            !Object.values(buttonRefs.current).some(btn => btn?.contains(event.target))
        ) {
            setDropdownOpenId(null);
        }
    }
    document.addEventListener('mousedown', handleClickOutsideDropdown);
    return () => document.removeEventListener('mousedown', handleClickOutsideDropdown);
    }, [dropdownOpenId]);
    const handleDropdownOptionClick = () => {
    setDropdownOpenId(null);
    };
    const handleOffboardedCheckboxChange = (setter, value) => (e) => {
        const isChecked = e.target.checked;
        setter((prev) => (isChecked ? [...prev, value] : prev.filter((v) => v !== value)));
        setOffboardedCurrentPage(1);
    };

    useEffect(() => {
        if (filterPopupOpen && filterButtonRef.current) {
            const rect = filterButtonRef.current.getBoundingClientRect();
            setFilterPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
        }
    }, [filterPopupOpen]);

    useEffect(() => {
        function handleClickOutsideFilter(event) {
            if (filterPopupOpen && filterPopupRef.current && !filterPopupRef.current.contains(event.target) && !filterButtonRef.current.contains(event.target)) {
                setFilterPopupOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutsideFilter);
        return () => document.removeEventListener('mousedown', handleClickOutsideFilter);
    }, [filterPopupOpen]);

    const filterCount = [...filterStatus, ...filterDepartments, ...filterEntities, ...filterManagers, ...filterWorkplaces, ...filterOnboardDate].filter(Boolean).length;

     useEffect(() => {
            // debug log to check what's coming in
            console.log('location.state on mount:', location.state);
    
            if (location && location.state && location.state.success) {
                setSuccessMessage(location.state.success);
    
                // clear that location.state so it doesn't reappear on refresh/back
                // for react-router v5: history.replace(pathname, state)
                history.replace(location.pathname, {});
    
                // auto-hide the success message after 3-4s
                const t = setTimeout(() => setSuccessMessage(''), 4000);
                return () => clearTimeout(t);
            }
        }, [location, history]);
    
    
        useEffect(() => {
            if (successMessage) {
                const t = setTimeout(() => setSuccessMessage(""), 4000);
                return () => clearTimeout(t);
            }
        }, [successMessage]);

    return (
        <div className="company-body">
            {/* Breadcrumbs */}
            <div className="breadcrumb">
                {breadcrumbs.map((crumb, index) => (
                    <span key={index} className="breadcrumb-item">
                        {crumb}
                        {index !== breadcrumbs.length - 1}
                    </span>
                ))}
            </div>
             {successMessage && (
                <div
                    className="d-flex align-items-center justify-content-between"
                    role="alert"
                    style={{
                        boxShadow: "0px 4px 10px 0px #0000001F",
                        padding: "15px 10px",
                        borderRadius: "12px",
                        border: "1px solid #30B473",
                        backgroundColor: "#E6F7EF",
                        color: "#0D6438",
                        fontSize: "12px",
                        position: "fixed",
                        top: "10px",
                        width: "calc(100% - 20px)",
                        maxWidth: "640px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 2000,
                    }}
                >
                    <div className="d-flex align-items-center">
                        <CircleCheck className="me-2" />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                            }}>
                            <strong>{successMessage}</strong>
                        </div>
                    </div>
     <X
                        size={16}
                        style={{ cursor: "pointer" }}
                        onClick={() => setSuccessMessage("")}
                    />
                </div>
            )}

            <div className="employee-tabs-container">
                {/* ─── Tab Buttons ─── */}
                <div className="tabs">
                    <button
                        // Apply the "active" class only when this tab is selected
                        className={`tab ${activeTab === 'current-employees' ? 'active' : ''
                            }`}
                        onClick={() => setActiveTab('current-employees')}
                    >
                        Current Employees
                    </button>

                    <button
                        className={`tab ${activeTab === 'offboarded-employees' ? 'active' : ''
                            }`}
                        onClick={() => setActiveTab('offboarded-employees')}
                    >
                        Offboarded Employees
                    </button>
                </div>

                {/* ─── Tab Contents ─── */}
                {activeTab === 'current-employees' && (
                    <div className="tab-content" id="current-employees-content">
                        {/* Current Employees Card */}
                        <div className="info-section">
                            <div className="info-card">
                                <div className="info-header">
                                    <h4 className="info-title">Current Employees</h4>
                                </div>

                                <div className="entities-tab">
                                    {/* Toolbar: Search + Filter on left; Edit/Plus on right */}
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <div className="search-box">
                                                <Search size={20} />
                                                <input
                                                    type="text"
                                                    placeholder="Search…"
                                                    value={searchTerm}
                                                    onChange={e => {
                                                        setSearchTerm(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                />
                                            </div>
                                            <button
                                                ref={filterButtonRef}
                                                className="icon-btn new-look"
                                                onClick={() => setFilterPopupOpen(!filterPopupOpen)}
                                            >
                                                <Funnel size={18} /> Filter
                                                {filterCount > 0 && (
                                                    <span style={{ background: '#000', color: '#ffffff', borderRadius: '50%', width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', marginLeft: '5px' }}>
                                                        {filterCount}
                                                    </span>
                                                )}
                                            </button>
                                        </div>
                                        <div className="toolbar-right">
                                            <button className="icon-btn"><MoreHorizontal size={18} /></button>
                                            <button className="icon-btn" onClick={editEmployee}><Edit2 size={18} /></button>
                                            <button className="icon-btn" onClick={() => history.push('/employee/add-employee')}><Plus size={18} /></button>
                                        </div>
                                    </div>

                                    {filterPopupOpen && (
                                        <div
                                            ref={filterPopupRef}
                                            className="filter-popup"
                                            style={{ position: 'absolute', top: filterPosition.top, left: filterPosition.left, background: '#fff', padding: '16px', borderRadius: '8px', width: '300px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', zIndex: '1002',maxHeight:'300px',overflowY:'auto',scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                                        >
                                            <div className="filter-header" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                                                <button className="close-btn" onClick={() => setFilterPopupOpen(false)}><X size={20} /></button>
                                            </div>
                                            <div className="filter-content">
                                                <div className="filter-section" style={{ marginBottom: '16px' }}>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>Status</label>
                                                    <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                                                        {['Active', 'Inactive'].map((status) => (
                                                            <label key={status} className="form-check" style={{ cursor: 'pointer', fontWeight: '400' }}>
                                                                <input type="checkbox" className="form-check-input" checked={filterStatus.includes(status)} onChange={handleCheckboxChange(setFilterStatus, status)} />
                                                                <span style={{ marginLeft: '8px' }}>{status}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="filter-section" style={{ marginBottom: '16px' }}>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>Departments</label>
                                                    <div className="search-box-filter" style={{ position: 'relative', border: '1px solid #6c757d', borderRadius: '.5rem', padding: '4px', minHeight: '32px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                                                        {filterDepartments.map((dept) => (
                                                            <span key={dept} style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}>
                                                                {dept}
                                                                <button onClick={() => handleCheckboxChange(setFilterDepartments, dept)({ target: { checked: false } })} style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}><X size={14} strokeWidth={3} /></button>
                                                            </span>
                                                        ))}
                                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                                                            <Search size={16} style={{ marginRight: '4px' }} />
                                                            <input type="text" placeholder="Search Departments…" value={departmentSearchTerm} onChange={(e) => setDepartmentSearchTerm(e.target.value)} style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px' }} />
                                                        </div>
                                                    </div>
                                                    <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                                                        {allDepartments.filter((d) => d.short_name.toLowerCase().includes(departmentSearchTerm.toLowerCase())).map((dept, index) => (
                                                            <label key={index} className="form-check" style={{ cursor: 'pointer', fontWeight: '400' }}>
                                                                <input type="checkbox" className="form-check-input" checked={filterDepartments.includes(dept.short_name)} onChange={handleCheckboxChange(setFilterDepartments, dept.short_name)} />
                                                                <span style={{ marginLeft: '8px' }}>{dept.short_name}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="filter-section" style={{ marginBottom: '16px' }}>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>Entities</label>
                                                    <div className="search-box-filter" style={{ position: 'relative', border: '1px solid #6c757d', borderRadius: '.5rem', padding: '4px', minHeight: '32px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                                                        {filterEntities.map((entity) => (
                                                            <span key={entity} style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}>
                                                                {entity}
                                                                <button onClick={() => handleCheckboxChange(setFilterEntities, entity)({ target: { checked: false } })} style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}><X size={14} strokeWidth={3} /></button>
                                                            </span>
                                                        ))}
                                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                                                            <Search size={16} style={{ marginRight: '4px' }} />
                                                            <input type="text" placeholder="Search Entities…" value={entitySearchTerm} onChange={(e) => setEntitySearchTerm(e.target.value)} style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px' }} />
                                                        </div>
                                                    </div>
                                                    <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                                                        {allEntities.filter((e) => e.entity_short_name.toLowerCase().includes(entitySearchTerm.toLowerCase())).map((entity, index) => (
                                                            <label key={index} className="form-check" style={{ cursor: 'pointer', fontWeight: '400' }}>
                                                                <input type="checkbox" className="form-check-input" checked={filterEntities.includes(entity.entity_short_name)} onChange={handleCheckboxChange(setFilterEntities, entity.entity_short_name)} />
                                                                <span style={{ marginLeft: '8px' }}>{entity.entity_short_name}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="filter-section" style={{ marginBottom: '16px' }}>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>Managers</label>
                                                    <div className="search-box-filter" style={{ position: 'relative', border: '1px solid #6c757d', borderRadius: '.5rem', padding: '4px', minHeight: '32px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                                                        {filterManagers.map((manager) => (
                                                            <span key={manager} style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}>
                                                                {manager}
                                                                <button onClick={() => handleCheckboxChange(setFilterManagers, manager)({ target: { checked: false } })} style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}><X size={14} strokeWidth={3} /></button>
                                                            </span>
                                                        ))}
                                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                                                            <Search size={16} style={{ marginRight: '4px' }} />
                                                            <input type="text" placeholder="Search Managers…" value={managerSearchTerm} onChange={(e) => setManagerSearchTerm(e.target.value)} style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px' }} />
                                                        </div>
                                                    </div>
                                                    <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                                                        {allManagers.filter((m) => m?.display_name?.toLowerCase().includes(managerSearchTerm?.toLowerCase())).map((manager, index) => (
                                                            <label key={index} className="form-check" style={{ cursor: 'pointer', fontWeight: '400' }}>
                                                                <input type="checkbox" className="form-check-input" checked={filterManagers.includes(manager.display_name)} onChange={handleCheckboxChange(setFilterManagers, manager.display_name)} />
                                                                <span style={{ marginLeft: '8px' }}>{manager.display_name}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="filter-section" style={{ marginBottom: '16px' }}>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>Workplaces</label>
                                                    <div className="search-box-filter" style={{ position: 'relative', border: '1px solid #6c757d', borderRadius: '.5rem', padding: '4px', minHeight: '32px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                                                        {filterWorkplaces.map((workplace) => (
                                                            <span key={workplace} style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}>
                                                                {workplace}
                                                                <button onClick={() => handleCheckboxChange(setFilterWorkplaces, workplace)({ target: { checked: false } })} style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}><X size={14} strokeWidth={3} /></button>
                                                            </span>
                                                        ))}
                                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                                                            <Search size={16} style={{ marginRight: '4px' }} />
                                                            <input type="text" placeholder="Search Workplaces…" value={workplaceSearchTerm} onChange={(e) => setWorkplaceSearchTerm(e.target.value)} style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px' }} />
                                                        </div>
                                                    </div>
                                                    <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                                                        {allWorkplaces.filter((w) => w.workplace_short_name && w.workplace_short_name.toLowerCase().includes((workplaceSearchTerm || '').toLowerCase())).map((workplace, index) => (
                                                            <label key={index} className="form-check" style={{ cursor: 'pointer', fontWeight: '400' }}>
                                                                <input type="checkbox" className="form-check-input" checked={filterWorkplaces.includes(workplace.workplace_short_name)} onChange={handleCheckboxChange(setFilterWorkplaces, workplace.workplace_short_name)} />
                                                                <span style={{ marginLeft: '8px' }}>{workplace.workplace_short_name}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="filter-section">
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>Onboard Date</label>
                                                    <div className="search-box-filter" style={{ position: 'relative', border: '1px solid #6c757d', borderRadius: '.5rem', padding: '4px', minHeight: '32px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                                                        {filterOnboardDate.map((date) => (
                                                            <span key={date} style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}>
                                                                {date}
                                                                <button onClick={() => handleCheckboxChange(setFilterOnboardDate, date)({ target: { checked: false } })} style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}><X size={14} strokeWidth={3} /></button>
                                                            </span>
                                                        ))}
                                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                                                            <Search size={16} style={{ marginRight: '4px' }} />
                                                            <input type="text" placeholder="Search Onboard Date…" value={onboardDateSearchTerm} onChange={(e) => setOnboardDateSearchTerm(e.target.value)} style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px' }} />
                                                        </div>
                                                    </div>
                                                    <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                                                        {[...new Set(employeeData.map((e) => e.onboard_date))].filter((d) => d?.toLowerCase().includes(onboardDateSearchTerm.toLowerCase())).map((date, index) => (
                                                            <label key={index} className="form-check" style={{ cursor: 'pointer', fontWeight: '400' }}>
                                                                <input type="checkbox" className="form-check-input" checked={filterOnboardDate.includes(date)} onChange={handleCheckboxChange(setFilterOnboardDate, date)} />
                                                                <span style={{ marginLeft: '8px' }}>{date}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="filter-footer" style={{ textAlign: 'center',marginTop:'10px' }}>
                                                <button style={{ background: 'black', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => setFilterPopupOpen(false)}>Filter</button>
                                            </div>
                                        </div>
                                    )}

                                    <div className="table-wrapper">
                                        <table className="entities-table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={selectedIds.length === pageData.length && pageData.length > 0}
                                                                onChange={toggleAll}
                                                            />
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Name <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Status <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Department <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Manager <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Job Title <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Workplace <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th style={{ textAlign: 'center' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pageData.map((row, idx) => {
                                                    const isRowSelected = selectedIds.includes(row.id) && !bulkEditOpen && !suppressHighlight;
                                                    return (
                                                        <tr
                                                            key={row.id}
                                                            className={[idx % 2 ? 'striped' : '', isRowSelected ? 'row-selected' : ''].join(' ')}
                                                            onClick={() => onRowClick(row)}
                                                        >
                                                            <td>
                                                                <div className="form-check" onClick={(e) => e.stopPropagation()}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={selectedIds.includes(row.id)}
                                                                        onChange={(e) => {
                                                                            toggleSelect(row.id);
                                                                            if (e.target.checked) setSelectedRow(row);
                                                                            else if (selectedRow?.id === row.id) setSelectedRow(null);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="name-cell">
                                                                    <img
                                                                        src={row.avatar_url}
                                                                        alt="avatar"
                                                                        className="avatar"
                                                                        style={{ width: 28, height: 28, borderRadius: '50%', marginRight: 8, verticalAlign: 'middle' }}
                                                                    />
                                                                    {row.employee_first_name + ' ' + row.employee_last_name }
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span className={`status ${row.status_name.toLowerCase()}`}>{row.status_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</span>
                                                            </td>
                                                            <td>{row.departments_names || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.manager || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.job_title_data?.job_title_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.workplaces_names || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td style={{ textAlign: 'center', position: 'relative' }}>
                                                                <button
                                                                    ref={(el) => (buttonRefs.current[row.id] = el)}
                                                                    className="icon-btn"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        toggleDropdown(row.id);
                                                                    }}
                                                                >
                                                                    <MoreHorizontal size={20} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                {pageData.length < PAGE_SIZE &&
                                                    [...Array(PAGE_SIZE - pageData.length)].map((_, idx) => (
                                                        <tr key={`empty-${idx}`} className="empty-row" onClick={() => { /* Do nothing */ }}>
                                                            <td colSpan={8}>&nbsp;</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>

                                        {dropdownOpenId !== null && (
                                            <div
                                                ref={dropdownRef}
                                                className="backdrop-cls"
                                                style={{
                                                    position: 'absolute',
                                                    top: dropdownPosition.top,
                                                    left: dropdownPosition.left,
                                                    background: 'white',
                                                    boxShadow: '0px 1px 4px 0px #0000001A',
                                                    zIndex: 1000,
                                                    minWidth: 152,
                                                    borderRadius: 8,
                                                    padding: 12,
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                handleDropdownOptionClick();
                                                                const row = pageData.find((d) => d.id === dropdownOpenId);
                                                                onRowClick(row);
                                                            }}
                                                        >
                                                            View Details
                                                        </button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button onClick={() => { handleDropdownOptionClick(); editEmployee(); }}>Edit</button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button onClick={() => { handleDropdownOptionClick(); alert('Suspend clicked'); }}>Suspend</button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                handleDropdownOptionClick();
                                                                setOffboardModalOpen(true);
                                                            }}
                                                            className="deactivate-cls"
                                                        >
                                                            Offboard
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {filtered.length > 0 && (
                                        <div className="pagination">
                                            <div className="pagination-info">
                                                {`Showing ${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(currentPage * PAGE_SIZE, filtered.length)} of ${filtered.length} items`}
                                            </div>
                                            <div className="pagination-controls">
                                                <button
                                                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                                                    disabled={currentPage === 1}
                                                >
                                                    <ChevronLeft size={20} />
                                                </button>
                                                {[...Array(totalPages)].map((_, i) => (
                                                    <button
                                                        key={i}
                                                        className={currentPage === i + 1 ? 'active' : ''}
                                                        onClick={() => setCurrentPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                ))}
                                                <button
                                                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <ChevronRight size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'offboarded-employees' && (
                    <div className="tab-content" id="offboarded-employees-content">
                        <div className="info-section">
                            <div className="info-card">
                                <div className="info-header">
                                    <h4 className="info-title">Offboarded Employees</h4>
                                </div>

                                <div className="entities-tab">
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <div className="search-box">
                                                <Search size={20} />
                                                <input
                                                    type="text"
                                                    placeholder="Search…"
                                                    value={offboardedSearchTerm}
                                                    onChange={(e) => {
                                                        setOffboardedSearchTerm(e.target.value);
                                                        setOffboardedCurrentPage(1);
                                                    }}
                                                />
                                            </div>
                                            <button
                                                ref={filterButtonRef}
                                                className="icon-btn new-look"
                                                onClick={() => setFilterPopupOpen(!filterPopupOpen)}
                                            >
                                                <Funnel size={18} /> Filter
                                                {offboardedFilterWorkplaces.length > 0 && (
                                                    <span style={{ background: '#000', color: '#ffffff', borderRadius: '50%', width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', marginLeft: '5px' }}>
                                                        {offboardedFilterWorkplaces.length}
                                                    </span>
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    {filterPopupOpen && (
                                        <div
                                            ref={filterPopupRef}
                                            className="filter-popup"
                                            style={{ position: 'absolute', top: filterPosition.top, left: filterPosition.left, background: '#fff', padding: '16px', borderRadius: '8px', width: '300px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', zIndex: '1002',maxHeight:'300px',overflowY:'scroll' }}
                                        >
                                            <div className="filter-header" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                                                <button className="close-btn" onClick={() => setFilterPopupOpen(false)}><X size={20} /></button>
                                            </div>
                                            <div className="filter-content">
                                                <div className="filter-section" style={{ marginBottom: '16px' }}>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>Workplaces</label>
                                                    <div className="search-box-filter" style={{ position: 'relative', border: '1px solid #6c757d', borderRadius: '.5rem', padding: '4px', minHeight: '32px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                                                        {offboardedFilterWorkplaces.map((workplace) => (
                                                            <span key={workplace} style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}>
                                                                {workplace}
                                                                <button onClick={() => handleOffboardedCheckboxChange(setOffboardedFilterWorkplaces, workplace)({ target: { checked: false } })} style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}><X size={14} strokeWidth={3} /></button>
                                                            </span>
                                                        ))}
                                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: '100px' }}>
                                                            <Search size={16} style={{ marginRight: '4px' }} />
                                                            <input type="text" placeholder="Search Workplaces…" value={offboardedWorkplaceSearchTerm} onChange={(e) => setOffboardedWorkplaceSearchTerm(e.target.value)} style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px' }} />
                                                        </div>
                                                    </div>
                                                    <div className="filter-options" style={{ maxHeight: '90px', overflowY: 'auto' }}>
                                                        {allWorkplaces.filter((w) => w.short_name && w.short_name.toLowerCase().includes((offboardedWorkplaceSearchTerm || '').toLowerCase())).map((workplace, index) => (
                                                            <label key={index} className="form-check" style={{ cursor: 'pointer', fontWeight: '400' }}>
                                                                <input type="checkbox" className="form-check-input" checked={offboardedFilterWorkplaces.includes(workplace.short_name)} onChange={handleOffboardedCheckboxChange(setOffboardedFilterWorkplaces, workplace.short_name)} />
                                                                <span style={{ marginLeft: '8px' }}>{workplace.short_name }</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="filter-footer" style={{ textAlign: 'center' }}>
                                                <button style={{ background: 'black', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => setFilterPopupOpen(false)}>Filter</button>
                                            </div>
                                        </div>
                                    )}

                                    <div className="table-wrapper">
                                        <table className="entities-table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div
                                                            className="form-check"
                                                            onClick={(e) => e.stopPropagation()}
                                                            onMouseDown={(e) => e.stopPropagation()}
                                                        >
                                                            <input className="form-check-input" type="checkbox" checked={offboardedSelectedIds.length === offboardedPageData.length && offboardedPageData.length > 0} onChange={toggleOffboardedAll} />
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Name <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Email <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Department <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Manager <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Job Title <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Entity <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Workplace <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {offboardedPageData.map((row, idx) => {
                                                    const isRowSelected = offboardedSelectedIds.includes(row.id) && !bulkEditOpen && !suppressHighlight;
                                                    return (
                                                        <tr
                                                            key={row.id}
                                                            className={[idx % 2 ? 'striped' : '', isRowSelected ? 'row-selected' : ''].join(' ')}
                                                            onClick={() => onRowClick(row)}
                                                        >
                                                            <td>
                                                                <div
                                                                    className="form-check"
                                                                    onClick={(e) => e.stopPropagation()} // prevents tr.onClick
                                                                    onMouseDown={(e) => e.stopPropagation()} // prevents some browsers from firing tr events
                                                                >
                                                                    <input type="checkbox" className="form-check-input" checked={offboardedSelectedIds.includes(row.id)} onChange={(e) => toggleOffboardedSelect(row.id)} />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="name-cell">
                                                                    <img
                                                                        src={row.avatar}
                                                                        alt="avatar"
                                                                        className="avatar"
                                                                        style={{ width: 28, height: 28, borderRadius: '50%', marginRight: 8, verticalAlign: 'middle' }}
                                                                    />
                                                                    {row.name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </td>
                                                            <td>{row.email || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.department || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.manager || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.jobTitle || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.entity || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                            <td>{row.workplace || <span style={{ color: '#ADB5BD' }}>NA</span>}</td>
                                                        </tr>
                                                    );
                                                })}
                                                {offboardedPageData.length < PAGE_SIZE &&
                                                    [...Array(PAGE_SIZE - offboardedPageData.length)].map((_, idx) => (
                                                        <tr key={`empty-off-${idx}`} className="empty-row">
                                                            <td colSpan={8}>&nbsp;</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* {offboardedFiltered > 0 && ( */}
                                        <div className="pagination">
                                            <div className="pagination-info">
                                                {`Showing ${(offboardedCurrentPage - 1) * PAGE_SIZE + 1} - ${Math.min(offboardedCurrentPage * PAGE_SIZE, offboardedFiltered.length)} of ${offboardedFiltered.length} items`}
                                            </div>
                                            <div className="pagination-controls">
                                                <button
                                                    onClick={() => setOffboardedCurrentPage((p) => Math.max(1, p - 1))}
                                                    disabled={offboardedCurrentPage === 1}
                                                >
                                                    <ChevronLeft size={20} />
                                                </button>
                                                {[...Array(offboardedTotalPages)].map((_, i) => (
                                                    <button
                                                        key={i}
                                                        className={offboardedCurrentPage === i + 1 ? 'active' : ''}
                                                        onClick={() => setOffboardedCurrentPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                ))}
                                                <button
                                                    onClick={() => setOffboardedCurrentPage((p) => Math.min(offboardedTotalPages, p + 1))}
                                                    disabled={offboardedCurrentPage === offboardedTotalPages}
                                                >
                                                    <ChevronRight size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    {/* )} */}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {drawerOpen && selectedRow && (
                <>
                    <div className="drawer-overlay" />
                    <div className="entity-drawer" ref={drawerRef}>
                        <div className="drawer-header">
                            <h3>Employee Info</h3>
                            <button
                                className="close-btn"
                                onClick={() => {
                                    setDrawerOpen(false);
                                    setSelectedIds((ids) => ids.filter((id) => id !== selectedRow?.id));
                                    setSelectedRow(null);
                                }}
                            >
                                <X size={24} />
                            </button>
                        </div>
                        <div className="main-drawer-inner">
                            <div className="drawer-title d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <img
                                        src="https://avatar.iran.liara.run/public"
                                        alt="avatar"
                                        className="avatar"
                                        style={{ width: 28, height: 28, borderRadius: '50%', marginRight: 8, verticalAlign: 'middle' }}
                                    />
                                    <h2 className="pb-0">{selectedRow.employee_first_name + ' ' + selectedRow.employee_last_name} </h2>
                                </div>
                                <div className="entities-tab" style={{ display: 'none' }}>
                                    <div className="toolbar">
                                        <div className="toolbar-right">
                                            <button className="icon-btn"><Edit2 size={18} /></button>
                                            <button className="icon-btn"><MoreHorizontal size={18} /></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="drawer-tabs">
                                <button
                                    className={drawerTab === 'entity-info' ? 'active' : ''}
                                    onClick={() => setDrawerTab('entity-info')}
                                >
                                    Basic Info
                                </button>
                                <button
                                    className={drawerTab === 'contact-info' ? 'active' : ''}
                                    onClick={() => setDrawerTab('contact-info')}
                                >
                                    Contact Info
                                </button>
                                <button
                                    className={drawerTab === 'position-info' ? 'active' : ''}
                                    onClick={() => setDrawerTab('position-info')}
                                >
                                    Position Info
                                </button>
                                <button
                                    className={drawerTab === 'additional-info' ? 'active' : ''}
                                    onClick={() => setDrawerTab('additional-info')}
                                >
                                    Additional Info
                                </button>
                            </div>

                            <div className="drawer-content">
                                {drawerTab === 'entity-info' && (
                                    <div className="tab-panel entity-info-panel">
                                        <div className="field-block">
                                            <div className="field-label">Employee Name</div>
                                            <div className="field-value">{selectedRow.employee_first_name + ' ' + selectedRow.employee_last_name }</div>
                                        </div>
                                        <div className="field-block" style={{ position: "relative" }}>
                                            <div className="field-label">Open ID</div>
                                            <div className="field-value d-flex align-items-center gap-2">
                                                <span
                                                ref={openIdRef}
                                                onClick={handleCopy}
                                                style={{
                                                    color: copied ? "#60aaffff" : "#2C7BE5", // green if copied
                                                    cursor: "pointer",
                                                    textDecoration: "underline",
                                                    transition: "color 0.3s"
                                                }}
                                                >
                                                {selectedRow.uuid || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                </span>
                                                <div style={{ position: "relative" }}>
                                                {selectedRow.uuid &&<Copy
                                                    size={13}
                                                    onClick={handleCopy}
                                                    style={{ cursor: "pointer", color: copied ? "#60aaffff" : "#2C7BE5" }}
                                                />}
                                                {copied && <span style={{ fontSize: '12px', color: "#2C7BE5" }}>Copied!</span>}
                                                
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Status</div>
                                            <div className="field-value">
                                                <span className={`status ${selectedRow.status_name.toLowerCase()}`}>{selectedRow.status_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</span>
                                            </div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Display Name</div>
                                            <div className="field-value">{selectedRow.display_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                    </div>
                                )}
                                {drawerTab === 'contact-info' && (
                                    <div className="tab-panel contact-info-panel">
                                        <div className="field-block">
                                            <div className="field-label">Work Email</div>
                                            <div className="field-value">{selectedRow.company_email || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Personal Email</div>
                                            <div className="field-value">{selectedRow.personal_email|| <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Phone Number</div>
                                            <div className="field-value">{selectedRow.country_code_data?.country_code || <span style={{ color: '#ADB5BD' }}>NA</span>} {selectedRow.phone_number|| <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                    </div>
                                )}
                                {drawerTab === 'position-info' && (
                                    <div className="tab-panel position-info-panel">
                                        <div className="field-block">
                                            <div className="field-label">Department</div>
                                            <div className="field-value">{selectedRow.departments_names || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Manager</div>
                                            <div className="field-value">{selectedRow.manager || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Entities</div>
                                            <div className="field-value">{selectedRow.entities_names || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Workplace</div>
                                            <div className="field-value">{selectedRow.workplaces_names || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Job Title</div>
                                            <div className="field-value">{selectedRow.job_title_data?.job_title_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                        <div className="field-block">
                                            <div className="field-label">Onboard Date</div>
                                            <div className="field-value">{formattedDate || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                        </div>
                                    </div>
                                )}
                                {drawerTab === 'additional-info' && (
                                    <div className="tab-panel additional-info-panel">
                                        <p className="note-type-added">Note</p>
                                        <label className="no-description-cls when-no-description-cls-adding">{selectedRow.notes || <span style={{ color: '#ADB5BD' }}>NA</span>}</label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    </>
                )}

                {bulkEditOpen && (
                    <>
                        <div className="drawer-overlay" />
                        <div className="entity-drawer main-company-body-inner new-main-entity-cls-adding-here" ref={bulkDrawerRef}>
                            <div className="drawer-header">
                                <h3>Batch Edit</h3>
                                <button className="close-btn" onClick={handleBulkCancel}><X size={24} /></button>
                            </div>
                            <div className="main-drawer-inner">
                                <div className="drawer-title info-inner">
                                    <label>Selected Employees</label>
                                    <div className="selected-tags">
                                        {selectedIds.map((id) => {
                                            const row = employeeData.find((d) => d.id === id);
                                            return (
                                                <div key={id} className="tag">
                                                    {row.name}
                                                    <span className="tag-close" onClick={() => removeSelectedId(id)}><X size={14} strokeWidth={3} /></span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className="drawer-content">
                                    <div className="grid-info-adding">
                                        <div className="row gappingcls-added">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="info-inner">
                                                    <label htmlFor="status" className="form-label">
                                                        Status <span className="error-color">*</span>
                                                    </label>
                                                    <div className="flexing-type-radio">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                                            <label className="form-check-label" htmlFor="flexRadioDefault1">Active</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" defaultChecked />
                                                            <label className="form-check-label" htmlFor="flexRadioDefault2">Inactive</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gappingcls-added">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="info-inner">
                                                    <label htmlFor="departments" className="form-label d-flex align-items-center gap-1">
                                                        Departments
                                                        <Tooltip content="Select a new departments for all selected employees">
                                                            <Info size={16} className="info-icon" />
                                                        </Tooltip>
                                                    </label>
                                                    <select className="form-select new-form-select-cls" aria-label="Default select example">
                                                        <option defaultValue>Select Departments</option>
                                                        <option value="1">Jane Doe</option>
                                                        <option value="2">Serene</option>
                                                        <option value="3">Hau Jie</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gappingcls-added">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="info-inner">
                                                    <label htmlFor="manager" className="form-label d-flex align-items-center gap-1">
                                                        Manager
                                                        <Tooltip content="Choose a new manager location">
                                                            <Info size={16} className="info-icon" />
                                                        </Tooltip>
                                                    </label>
                                                    <select className="form-select new-form-select-cls" aria-label="Default select example">
                                                        <option defaultValue>Select manager</option>
                                                        <option value="1">Mister Mobile HQ</option>
                                                        <option value="2">Remote</option>
                                                        <option value="3">Branch Office</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gappingcls-added">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="info-inner">
                                                    <label htmlFor="entities" className="form-label d-flex align-items-center gap-1">
                                                        Entities
                                                        <Tooltip content="Choose a new entities location">
                                                            <Info size={16} className="info-icon" />
                                                        </Tooltip>
                                                    </label>
                                                    <select className="form-select new-form-select-cls" aria-label="Default select example">
                                                        <option defaultValue>Select entities</option>
                                                        <option value="1">Mister Mobile HQ</option>
                                                        <option value="2">Remote</option>
                                                        <option value="3">Branch Office</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gappingcls-added">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="info-inner">
                                                    <label htmlFor="entities" className="form-label d-flex align-items-center gap-1">
                                                        Workplaces
                                                        <Tooltip content="Choose a new workplaces location">
                                                            <Info size={16} className="info-icon" />
                                                        </Tooltip>
                                                    </label>
                                                    <select className="form-select new-form-select-cls" aria-label="Default select example">
                                                        <option defaultValue>Select workplaces</option>
                                                        <option value="1">Mister Mobile HQ</option>
                                                        <option value="2">Remote</option>
                                                        <option value="3">Branch Office</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gappingcls-added">
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="info-inner">
                                                    <label htmlFor="entities" className="form-label d-flex align-items-center gap-1">
                                                        Job Title
                                                        <Tooltip content="Choose a new Job Title location">
                                                            <Info size={16} className="info-icon" />
                                                        </Tooltip>
                                                    </label>
                                                    <select className="form-select new-form-select-cls" aria-label="Default select example">
                                                        <option defaultValue>Select Job Title</option>
                                                        <option value="1">Mister Mobile HQ</option>
                                                        <option value="2">Remote</option>
                                                        <option value="3">Branch Office</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="drawer-footer">
                                    <button className="btn-cancel" onClick={handleBulkCancel}>Cancel</button>
                                    <button className="btn-save" onClick={handleBulkSave}>Save</button>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {offboardModalOpen && (
                    <>
                        <div className="drawer-overlay" />
                        <div
                            className="entity-drawer modal-popup-cls"
                            ref={offboardRef}
                            style={{
                                maxWidth: 650,
                                margin: '0 auto',
                                background: 'white',
                                borderRadius: 12,
                                zIndex: 1050,
                                padding: 24,
                                position: 'fixed',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
                                height: 'auto',
                                right: 'auto',
                                overflow: 'inherit',
                            }}
                        >
                            <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                <button className="close-btn" onClick={() => setOffboardModalOpen(false)}><X size={20} /></button>
                            </div>
                            <h3 style={{ textAlign: 'left', color: '#212529', fontSize: '20px', fontWeight: '600', lineHeight: '24px', fontFamily: 'Montserrat', marginBottom: '5px' }}>
                                Are you sure you would like to offboard this employee?
                            </h3>
                            <p
                                style={{ marginBottom: '0', textAlign: 'left', color: '#6C757D', fontSize: '14px', fontWeight: '400', lineHeight: '20px', fontFamily: 'Montserrat' }}
                            >
                                If you would like to offboard this employee, confirm offboard date below
                            </p>
                            <div className="drawer-content">
                                <div className="row gappingcls-added">
                                    <div className="col-12">
                                        <div className="info-inner tab-panel">
                                            <div className="field-block">
                                                <div className="field-label" style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                                    Offboard Date <span className="error-color" style={{ color: 'red' }}>*</span>
                                                    <Tooltip content="Choose offboard date for this employee">
                                                        <Info size={16} className="info-icon" />
                                                    </Tooltip>
                                                </div>
                                                <select className="form-select new-form-select-cls">
                                                    <option value="">Select Offboard Date</option>
                                                    <option value="2025-06-10">10 June 2025</option>
                                                    <option value="2025-06-15">15 June 2025</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="drawer-footer" style={{ paddingTop: '10px' }}>
                                <button className="btn-cancel" onClick={() => setOffboardModalOpen(false)}>Cancel</button>
                                <button className="btn-save" onClick={handleOffboardConfirm}>Offboard</button>
                            </div>
                        </div>
                    </>
                )}
        </div>
    )
}